import { ReactNode } from "react";

import { PaymentMethodOption, WalletType } from "common/types";
import { Optional } from "common/utils/types";

import PaymentMethod from "client/common/components/content/PaymentMethod";

import styles from "../styles/PaymentMethodSelectPanelOption.module.less";

type PaymentMethodSelectPanelOptionProps = {
  method: PaymentMethodOption;
  status: ReactNode;
  otherExistingWallet: Optional<WalletType>;
};

const PaymentMethodSelectPanelOption = ({
  method,
  status,
  otherExistingWallet,
}: PaymentMethodSelectPanelOptionProps) => {
  return (
    <div className={styles.option}>
      <PaymentMethod
        method={method}
        otherExistingWallet={otherExistingWallet}
        styles={{
          label: styles.number,
          description: styles.details,
        }}
      />
      {status}
    </div>
  );
};

export default PaymentMethodSelectPanelOption;
